var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 54C108 24.1766 83.8234 0 54 0C24.1766 0 0 24.1766 0 54C0 83.8234 24.1766 108 54 108C83.8234 108 108 83.8234 108 54Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 3.05176e-05H0V108H108V3.05176e-05Z",
    fill: "#73B06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0394 58.3104L74.9939 103.621C82.7196 109.878 94.0542 108.686 100.31 100.961L145.621 45.0061C151.878 37.2804 150.686 25.9458 142.961 19.6897L87.006 -25.6214C79.2803 -31.8775 67.9458 -30.6862 61.6896 -22.9605L16.3785 32.994C10.1224 40.7197 11.3137 52.0542 19.0394 58.3104Z",
    fill: "#405059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1415 43.5552C63.5983 47.4568 69.5244 48.3955 75.9199 46.371",
    stroke: "white",
    strokeWidth: 2.22222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.648 30.0604C49.9072 28.4239 49.1224 26.9397 47.895 26.7453C46.6677 26.5509 45.4626 27.72 45.2034 29.3564C44.9442 30.9929 45.7291 32.4771 46.9564 32.6714C48.1838 32.8658 49.3888 31.6968 49.648 30.0604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1309 36.6306C91.3901 34.9942 90.6053 33.51 89.3779 33.3156C88.1506 33.1212 86.9455 34.2902 86.6863 35.9267C86.4271 37.5631 87.212 39.0473 88.4393 39.2417C89.6667 39.4361 90.8717 38.2671 91.1309 36.6306Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8b8776dd4788cc354d9047626a860efd.svg";
export { ForwardRef as ReactComponent };